<p-toast></p-toast>

<app-page-shell>

    <app-page-hero
        eyebrow="Fleet Setup"
        title="Trailer Types"
        subtitle="Manage company-specific trailer classifications used by trailer assets and mobilization filters.">
        <div actions>
            <p-button label="New Trailer Type" icon="pi pi-plus" (onClick)="create()"></p-button>
        </div>
    </app-page-hero>

    <app-page-search-panel
        title="Trailer Type Search"
        [activeFilters]="activeFilterCount()"
        [resultText]="totalRecords + ' types found'"
        [collapsed]="false"
        (search)="search()"
        (clear)="clearSearch()">
        <div class="search-grid">
            <div class="field">
                <label for="type-keyword">Keyword</label>
                <input id="type-keyword" pInputText [(ngModel)]="keyword" placeholder="Code, name, description" />
            </div>
            <div class="field">
                <label for="type-active">Active</label>
                <p-select inputId="type-active" [options]="activeOptions" [(ngModel)]="active" optionLabel="label" optionValue="value" [showClear]="true" placeholder="Any status" styleClass="w-full"></p-select>
            </div>
        </div>
    </app-page-search-panel>

    <app-page-metric-strip [metrics]="metrics()"></app-page-metric-strip>

    <app-page-data-panel title="Trailer Type Directory" subtitle="Master data used to classify trailer fleet assets." [resultText]="totalRecords + ' total'">
        <p-table [value]="rows" [lazy]="true" [paginator]="true" [rows]="rowsPerPage" [first]="first"
            [totalRecords]="totalRecords" [loading]="isLoading" [rowsPerPageOptions]="[10, 20, 50]"
            (onLazyLoad)="loadTrailerTypes($event)" styleClass="p-datatable-sm" responsiveLayout="scroll">
            <ng-template pTemplate="header">
                <tr>
                    <th>Code</th>
                    <th>Name</th>
                    <th>Description</th>
                    <th>Active</th>
                    <th>Sort</th>
                    <th>Active Trailers</th>
                    <th>Updated</th>
                    <th></th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-row>
                <tr>
                    <td class="font-semibold">{{ row.code || '-' }}</td>
                    <td>{{ row.name || '-' }}</td>
                    <td>{{ row.description || '-' }}</td>
                    <td>
                        <div class="stacked-cell">
                            <p-tag [value]="row.active === false ? 'Inactive' : 'Active'" [severity]="activeSeverity(row)"></p-tag>
                            <p-select [options]="activeOptions" [ngModel]="row.active !== false" optionLabel="label" optionValue="value"
                                appendTo="body" styleClass="w-full" [disabled]="isUpdating(row)"
                                (onChange)="updateActive(row, $event.value)"></p-select>
                        </div>
                    </td>
                    <td>{{ row.sortOrder ?? 0 }}</td>
                    <td>{{ row.activeTrailerCount ?? 0 }}</td>
                    <td>{{ dateLabel(row.updatedAt) }}</td>
                    <td class="row-actions">
                        <p-button icon="pi pi-eye" [rounded]="true" [text]="true" (onClick)="view(row)" ariaLabel="View trailer type"></p-button>
                        <p-button icon="pi pi-pencil" [rounded]="true" [text]="true" severity="secondary" (onClick)="edit(row)" ariaLabel="Edit trailer type"></p-button>
                    </td>
                </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
                <tr>
                    <td colspan="8" class="empty-cell">No trailer types found.</td>
                </tr>
            </ng-template>
        </p-table>
    </app-page-data-panel>
</app-page-shell>
